export default [
    '/connectwise',
    '/ms-cw',
    '/chartec',
    '/bitdefender',
    '/auth/appdirect/login',
    '/auth/appdirect/callback',
    '/account/prosignup',
    '/account/termsofservice',
    '/account/dpa',
    '/account/cookiepolicy',
    '/account/privacypolicy',
    '/account/aitransparency',
    '/account/login',
    '/account/forgotpassword',
    '/account/signup',
    '/account/created',
    '/account/confirmemail',
    '/account/confirmationrequired',
    '/account/resendconfirmationemail',
    '/account/forgotpasswordconfirmation',
    '/account/resetpassword',
    '/unsubscribe',
    '/users/create',

    '/document/invalid',
    '/document/partplayed',
    '/document/:guid/alldone',
    '/document/:guid/delegate',
    '/document/sign/:guid',
    '/document/sign/:guid/disclosure',

    '/PartnerProgram/Connectwise',
    '/Third-Party/ConnectWiseDisclaimer',
    '/Third-Party/ConnectWiseLogin',
    '/Third-Party/ConnectWiseRegister',
    '/Third-Party/ConnectWiseSuccessLink',
];